// SupplierPortal.js
import React, { useState, useEffect, useRef, memo, useMemo } from 'react';
import DataTable_AgGrid from './DataTable_AgGrid';
import { DataTable_ManageInvitations } from './DataTable_ManageInvitations';
import { useNavigate } from 'react-router-dom';
import FormPage from './FormPage'; // Je formuliercomponent
import { SP_useUserPermissions } from './SPUserPermissionsContext';  // Importeer de custom hook
import './SupplierPortal.css';
import InsertForm from './InsertForm';
import { useAuth } from './AuthContext';
import api from './axios';
import MenuIconDataSubscriptions from './MenuIcon Data Subscriptions.png';


let menuItemsCache = null;

const SupplierPortal = ({
  mode, // 'config' of 'user'
  expanded,
  SP_menuItems: propMenuItems, // alleen in config mode
  selectedSP_MenuItem,
  setSelectedSP_MenuItem,
  navigateTo,
  setModuleContent
}) => {

    const { companyId, logout } = useAuth(); // Haal de logout-functie uit de context

    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const [SP_menuItems, setSPMenuItems] = useState([]);
  
    // Haal de user permissies uit de context op
    const userPermission = SP_useUserPermissions();

    // Gebruik een ref om de laatst geladen module te onthouden
    const prevModuleId = useRef(null);

    useEffect(() => {
      if (mode !== 'user') return; // alleen in user-mode
    
      // als we al in de cache zitten, meteen teruggeven
      if (menuItemsCache) {
        setSPMenuItems(menuItemsCache);
        return;
      }
    
      const fetchMenuItems = async () => {
        try {
          // post via axios-instance; headers & cookies gaan automatisch mee
          const { data } = await api.post('/api/get_company_portal_modules', {
            companyId,
            roleId: 6 //6 = Supplier
          });
    
          if (Array.isArray(data.modules)) {
            menuItemsCache = data.modules;
            setSPMenuItems(data.modules);
          }
        } catch (err) {
          // 401 wordt automatisch door interceptor opgepakt, maar voor de zekerheid:
          if (err.response?.status === 401) {
            await logout();
            setError('Session expired');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);
            navigate(`/login/${companyId}`);
          } else {
            console.error('Error fetching menu items:', err);
          }
        }
      };
    
      fetchMenuItems();
    }, [mode, companyId, logout, navigate]);
     
    // Nieuwe functie die wordt aangeroepen wanneer een menu-item wordt geselecteerd
    const handleModuleSelect = (module) => {
      // (Optioneel) Als er een functie of prop beschikbaar is om de viewMode van de parent te resetten, doe dat dan hier.
      // Bijvoorbeeld: resetViewMode(); of setViewMode("table"); — afhankelijk van hoe je de state structureert.
      
      setSelectedSP_MenuItem(module.module_description);
    
      // Parse de JSON en voeg insert-form indien beschikbaar toe
      const jsonStr = module.module_json_definition || module.module_form_json_definition;
      try {
        const parsed = JSON.parse(jsonStr);
        parsed.module_id = module.id;
        if (module.module_insert_form_json_definition) {
          parsed.module_insert_form_json_definition = module.module_insert_form_json_definition;
        }
        // Stel de nieuwe moduleContent in (hiermee wordt in CustomerPortalContent de useEffect getriggerd)
        setModuleContent(parsed);
      } catch (e) {
        console.error('Error parsing module JSON:', e);
        setModuleContent(null);
      }
      prevModuleId.current = module.id;

      // Log de activiteit naar de backend
      //api.post('/api/log_activity', {
      //  companyId,                       // uit context
      //  moduleId:   module.id,           // het geopende module‐ID
      //  recordId:   null,                // recordId==null bij pure module‐open
      //  activityDesc: `Open module`
      //}).catch(err => {
      //  console.error('Logging failed:', err);
      //});
    };
    
    

if (mode === 'config') {
    return (
        <div className="content">
          <h3 style={{ visibility: expanded ? 'visible' : 'hidden' }}>
            <b>{ expanded ? 'Configure Supplier Portal' : 'CSP' }</b>
          </h3>
          <ul>
              {propMenuItems && propMenuItems.map((item, index) => (
              <li
                key={index}
                onClick={() => {
                  if (item.name !== selectedSP_MenuItem) {
                    setSelectedSP_MenuItem(item.name);
                  }
                }}
                className={`CP_menu-item ${item.name === selectedSP_MenuItem ? 'active-report' : ''}`}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {item.icon && (
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={{ marginRight: '10px', height: '25px' }}
                  />
                )}
                {expanded && <span className="cp-menu-text">{item.name}</span>}
              </li>
              ))}
          </ul>
          {/*}
          <hr style={{ margin: '10px 0', borderColor: 'lightgrey' }} />
          <ul>
            <li
              className={`CP_menu-item ${selectedSP_MenuItem === 'Data Subscriptions' ? 'active-report' : ''}`}
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              onClick={() => {
                setSelectedSP_MenuItem('Data Subscriptions');
              }}
            >
              <img 
                src={MenuIconDataSubscriptions} 
                alt="Data Subscriptions" 
                style={{ marginRight: '10px', height: '25px' }} 
              />
              {expanded && <span className="cp-menu-text">Data Subscriptions</span>}
            </li>
          </ul>
          {*/}
        </div>
    );
  } else if (mode === 'user') {
    return (
      <div className="content">
        <h3 style={{ visibility: expanded ? 'visible' : 'hidden' }}>
          <b>{ expanded ? 'Menu' : 'Menu' }</b>
        </h3>
        <ul>
          {SP_menuItems
            .filter(item => item.visible === 1)
            .map((item, index) => {
              // Zoek de permissie voor dit menu-item
              const permObj = userPermission.find(
                p => Number(p.company_portal_module_id) === Number(item.id)
              );    
              // Als er geen permissieobject is of als permission false is, gaan we ervan uit dat de toegang ontzegd is.
              const hasPermission = permObj ? permObj.permission : false;
              
              return (
                <li
                  key={index}
                  onClick={() => {
                    // Voer de actie alleen uit als de gebruiker toestemming heeft.
                    if (hasPermission && item.module_description !== selectedSP_MenuItem) {
                      handleModuleSelect(item);
                    }
                  }}
                  className={`CP_menu-item ${item.module_description === selectedSP_MenuItem ? 'active-report' : ''} ${!hasPermission ? 'disabled' : ''}`}
                  style={{
                    cursor: hasPermission ? 'pointer' : 'default',
                    color: hasPermission ? 'inherit' : 'lightgrey', 
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {item.module_icon_base64 && (
                    <img
                      src={`data:image/png;base64,${item.module_icon_base64}`}
                      alt={`${item.module_description} Icon`}
                      style={{ marginRight: '10px', height: '25px' }}
                    />
                  )}
                  {expanded && item.module_description}
                </li>
              );
            })}
        </ul>
        {/*}
        <hr style={{ margin: '10px 0', borderColor: 'lightgrey' }} />
        <ul>
          <li
            className={`CP_menu-item ${selectedSP_MenuItem === 'Data Subscriptions' ? 'active-report' : ''}`}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => {
              setSelectedSP_MenuItem('Data Subscriptions');
            }}
          >
            <img 
              src={MenuIconDataSubscriptions} 
              alt="Data Subscriptions" 
              style={{ marginRight: '10px', height: '25px' }} 
            />
            {expanded && <span className="cp-menu-text">Data Subscriptions</span>}
          </li>
        </ul>
        {*/}
      </div>
    );
  }
  
  return null;
};

export const SPConnectionAndSecurity = ({ user }) => {
  const navigate = useNavigate();
  const { companyId, logout, token } = useAuth(); // Haal de logout-functie uit de context
  
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [SPConnectionDetails, setSPConnectionDetails] = useState({});
  const [showPopup_iA_GW_Password, setShowPopup_iA_GW_Password] = useState(false);
  const [new_iA_GW_Password, setNew_iA_GW_Password] = useState('');  
  const [showNew_iA_GW_Password, setShowNew_iA_GW_Password] = useState(false);

  useEffect(() => {
    fetchConnectionDetails();
  }, []);  // draait eenmaal bij mount
  
  const fetchConnectionDetails = async () => {
    setIsLoading(true);
    try {
      // Axios-instance stuurt automatisch token/cookies mee
      const { data } = await api.post('/api/getCP_connectiondetails', {
        companyId,
        token
      });
  
      // Succes: update state
      setSPConnectionDetails(data);
    } catch (err) {
      // 401 → sessie verlopen
      if (err.response?.status === 401) {
        await logout();
        setError('Session expired');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
        navigate(`/login/${companyId}`);
        return;
      }
      // overige fouten
      console.error('Error fetching connection details:', err);
      setError(err.response?.data?.error || err.message || 'Something went wrong');
      setShowErrorPopup(true);
      setTimeout(() => setShowErrorPopup(false), 3000);
    } finally {
      setIsLoading(false);
    }
  };
  
  const update_iA_GW_password = async () => {
    try {
      // Axios-instance stuurt automatisch token/cookies mee
      await api.post('/api/update_iA_GW_password', {
        company_id: companyId,
        new_iA_GW_Password
      })
  
      // Succes: feedback en sluit popup
      setMessage('On-Premises Gateway Password updated successfully')
      setShowPopupMessage(true)
      setTimeout(() => setShowPopupMessage(false), 3000)
      setShowPopup_iA_GW_Password(false)
  
    } catch (err) {
      // 401 → sessie verlopen
      if (err.response?.status === 401) {
        await logout()
        setError('Session expired')
        setShowErrorPopup(true)
        setTimeout(() => setShowErrorPopup(false), 3000)
        navigate(`/login/${companyId}`)
        return
      }
      // overige fouten
      const msg = err.response?.data?.error || err.message || 'Failed to update password'
      console.error('Error updating gateway password:', err)
      setError(msg)
      setShowErrorPopup(true)
      setTimeout(() => setShowErrorPopup(false), 3000)
    }
  }  
  
    const toggleNew_iA_GW_PasswordVisibility = () => {
      setShowNew_iA_GW_Password((prevShowNewPassword) => !prevShowNewPassword);
    };


  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <div style={{ margin: '20px' }}>
        <h2 style={{ color: 'gray' }}>Connection and Security</h2>
        <div style={{ height: '10px' }}></div>

        {/* Tunnel Status */}
        <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px' }}>
          <tbody>
            <tr>
              <td style={{ width: '350px' }}>Cloud tunnel status</td>
              <td style={{
                width: '450px',
                fontWeight: 'bold',
                color: SPConnectionDetails.gw_tunnel_connection_status === 'Failed' ? 'red' :
                      SPConnectionDetails.gw_tunnel_connection_status === 'Success' ? 'green' : 'inherit'
              }}>
                {SPConnectionDetails.gw_tunnel_connection_status === 'Failed' ? 'Closed' :
                 SPConnectionDetails.gw_tunnel_connection_status === 'Success' ? 'Open' :
                 SPConnectionDetails.gw_tunnel_connection_status}
              </td>
              <td style={{ width: '100px' }} />
            </tr>
            <tr>
              <td>On-Premises database</td>
              <td style={{
                fontWeight: 'bold',
                color: SPConnectionDetails.gw_database_connection_status === 'Failed' ? 'red' :
                      SPConnectionDetails.gw_database_connection_status === 'Success' ? 'green' : 'inherit'
              }}>
                {SPConnectionDetails.gw_database_connection_status === 'Failed' ? 'Disconnected' :
                 SPConnectionDetails.gw_database_connection_status === 'Success' ? 'Connected' :
                 SPConnectionDetails.gw_database_connection_status}
              </td>
              <td/>
            </tr>
          </tbody>
        </table>

        <div>
          <button className="refresh-gateway-button" onClick={fetchConnectionDetails}>
            &#x21BB; Refresh
          </button>
        </div>

        <div style={{ height: '25px' }}></div>

        {/* Domain & Password */}
        <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px' }}>
          <tbody>
            <tr>
              <td style={{ width: '350px' }}>On-Premises gateway domain</td>
              <td style={{ fontWeight: 'bold', width: '450px' }}>
                {SPConnectionDetails.iA_GW_URL?.replace(/^https?:\/\//, '') ?? ''}
              </td>
              <td/>
            </tr>
            <tr>
              <td>On-Premises gateway password</td>
              <td style={{ fontWeight: 'bold' }}>********</td>
              <td style={{ width: '100px' }}>
                {user?.company_roleId < 3 && (
                  <button className="details-button" onClick={() => {
                    setNew_iA_GW_Password('');
                    setShowPopup_iA_GW_Password(true);
                  }}>Edit</button>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {showPopup_iA_GW_Password && (
      <div className="popup-container">
          <div className="popup-content">
          <h2 style={{ fontWeight: 'normal' }}>Edit On-Premises Gateway Password</h2>
          <div className="white-space"></div>

          <div className="password-input">
            <input
                type={showNew_iA_GW_Password ? 'text' : 'password'}
                id="newPassword"
                name="newPassword"
                placeholder="New password *"
                required
                onChange={(e) => setNew_iA_GW_Password(e.target.value)}
            />
            <button
                type="button"
                className="show-hide-button"
                onClick={toggleNew_iA_GW_PasswordVisibility}
            >
                {showNew_iA_GW_Password ? <img src="/Media/Show Icon.png" alt="Show" className="show-hide-icon" /> : <img src="/Media/Hide Icon.png" alt="Hide" className="show-hide-icon" />}
            </button>
        </div>
          <div className="buttons-container">
              <button onClick={() => setShowPopup_iA_GW_Password(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                  Cancel
              </button>
              <button
                disabled={!(new_iA_GW_Password)}
                style={{ 
                    color: (new_iA_GW_Password) ? 'black' : 'grey',
                    fontWeight: (new_iA_GW_Password) ? 'bold' : 'normal'
                }}
                onClick={() => update_iA_GW_password()}
            >
                Confirm
            </button>
          </div>
        </div>
      </div>
      )}

      {showPopupMessage && <div className="popup-message">{message}</div>}
      {showErrorPopup && <div className="popup">{error}</div>}
      {isLoading && (
        <div className="loader-wrapper-new">
            <div className="loader-new"></div>
        </div>
      )}
    </div>
  );
};

export const SPGeneralSettings = ({ user }) => {
  // ⬇️ Mock ERP apps
  const mockERPApps = [
    [1, 'Ridder iQ [On-Premises]'],
    [2, 'Ridder iQ [Cloud]'],
    //[3, 'SAP Business One']
  ];

  // ⬇️ Initialiseer met standaard: 'Ridder iQ [On-Premises]'
  const [selectedErpApplicationId, setSelectedErpApplicationId] = useState(() => {
    const ridder = mockERPApps.find(app => app[1] === 'Ridder iQ [On-Premises]');
    return ridder ? ridder[0] : '';
  });

  const selectedAppName = mockERPApps.find(app => app[0] === selectedErpApplicationId)?.[1];

  const [showPopup_ChangeERPApplication, setShowPopup_ChangeERPApplication] = useState(false); 

  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '100vh' }}>
      <div style={{ margin: '20px' }}>
        <h2 style={{ color: 'gray' }}>General settings</h2>

        {/* Tabel met ERP dropdown */}
        <table
          className="report-table-1"
          style={{
            borderBottom: '1px solid lightgrey',
            borderRadius: '10px',
            width: '100%',
            borderCollapse: 'separate',
            borderSpacing: 0
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: '350px', verticalAlign: 'middle', textAlign: 'left', padding: '12px 16px' }}>
                ERP Application
              </td>
              <td style={{ width: '450px', verticalAlign: 'middle', textAlign: 'left', padding: '12px 16px' }}>
                <select
                  style={{
                    width: '100%',
                    fontWeight: 'bold',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ccc'
                  }}
                  value={selectedErpApplicationId}
                  onChange={e => {
                    if (e.target.value !== '') {
                      setShowPopup_ChangeERPApplication(true);
                      setSelectedErpApplicationId(Number(e.target.value));
                    }
                  }}
                >
                  {mockERPApps.map((app, idx) => (
                    <option key={idx} value={app[0]}>
                      {app[1]}
                    </option>
                  ))}
                </select>
              </td>
              <td style={{ width: '100px' }}></td>
            </tr>
          </tbody>
        </table>
      </div>

      {showPopup_ChangeERPApplication && (
        <div className="popup-container">
          <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Change ERP Application</h2>
            <div className="white-space"></div>

            <div>
              Are you sure you want to change the ERP application? This will delete all current settings!
            </div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <div className="buttons-container">
              <button
                onClick={() => setShowPopup_ChangeERPApplication(false)}
                style={{ color: 'black', fontWeight: 'bold' }}
              >
                Cancel
              </button>
              <button
                style={{ color: 'black', fontWeight: 'bold' }}
                onClick={() => {
                  // TODO: implement logic
                  setShowPopup_ChangeERPApplication(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



export const InviteSuppliersTable = () => {
  const { user, companyId, logout } = useAuth();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);

  const autoLogin = Boolean(user?.autoLogin);


  useEffect(() => {
    // 1) Columns configuratie inladen
    const config = {
      tablename: "R_CONTACT",
      primaryKey: "PK_R_CONTACT",
      query: "SELECT c.PK_R_CONTACT AS PK_R_CONTACT, c.EMAIL AS EMAIL, c.EMPLOYMENTTERMINATED AS EMPLOYMENTTERMINATED, p.FIRSTNAME AS FIRSTNAME, p.NAMEPREFIX AS NAMEPREFIX, p.LASTNAME AS LASTNAME, r.NAME AS NAME, r.PK_R_RELATION AS PK_R_RELATION FROM R_CONTACT c JOIN R_PERSON p ON c.FK_PERSON = p.PK_R_PERSON JOIN R_RELATION r ON c.FK_RELATION = r.PK_R_RELATION;",
      columns: [
        { field: "PK_R_CONTACT", headerName: "ID",               order: 1, type: "integer", hide: true,  editable: false },
        { field: "NAME",        headerName: "Company Name",     order: 2, type: "string",  hide: false, editable: false },
        { field: "FIRSTNAME",   headerName: "First Name",       order: 3, type: "string",  hide: false, editable: false },
        { field: "NAMEPREFIX",  headerName: "Name Prefix",      order: 4, type: "string",  hide: false, editable: false },
        { field: "LASTNAME",    headerName: "Last Name",        order: 5, type: "string",  hide: false, editable: false },
        { field: "EMAIL",       headerName: "Email",            order: 6, type: "string",  hide: false, editable: false },
        {
          field: "", headerName: "", order: 7, type: "button",
          hide: false, editable: false, 
          buttontext: autoLogin ? 'Add' : 'Invite',
          function:  autoLogin ? 'handleAddSupplier' : 'handleInviteSupplier', 
          defaultWidth: 100
        }
      ]
    };

    setColumns(config.columns.sort((a, b) => a.order - b.order));

    // 2) Data ophalen via axios
    (async () => {
      try {
        const payload = {
          companyId,
          email: user.email,
          query: config.query,
          params: []
        };
        const { data: rows } = await api.post('/api/iAGateway_get_query', payload);

        if (Array.isArray(rows) && rows.length) {
          setData(rows);
        } else {
          setError('No data available');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
        }
      } catch (err) {
        // 401 → sessie verlopen
        if (err.response?.status === 401) {
          await logout();
          setError('Session expired');
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000);
          navigate(`/login/${companyId}`);
          return;
        }
        console.error('Error retrieving data:', err);
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [user, companyId, logout, navigate]);

  return (
    <div style={{ position: 'relative' }}>
        <div style={{ height: '80vh', width: '100%' }}>
        <DataTable_AgGrid
            initialData={data}
            columns={columns}
            isEditable={true}
            config={{
            tablename: "R_EMPLOYEE",
            primaryKey: "PK_R_EMPLOYEE"
            }}
        />
        </div>

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}
        {isLoading && (
        <div className="loader-wrapper-new">
            <div className="loader-new"></div>
        </div>
        )}
    </div>
  );
};

export const SupplierPortalContent = ({
  moduleContent,
  selectedSP_MenuItem,
  setModuleContent,
  standalone = false,
  initialViewMode,         // bv. 'form'
  initialNavigationPath,   // bv. [{moduleId:123,recordId:456}]
}) => {
  const { user, companyId, logout } = useAuth();
  const userEmail = user?.email;

  const navigate = useNavigate();
  const userPermission = SP_useUserPermissions();

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showPopupMessage, setShowPopupMessage] = useState(false);

  const [openFormRecord, setOpenFormRecord] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);


  // 🔽 Ref om ervoor te zorgen dat we auto‐log slechts één keer doen
  const autoLoggedRef = useRef(false);
  // 🔽 Auto‐form logging bij standalone mount
  useEffect(() => {
    if (
      standalone === true &&
      initialViewMode === 'form' &&
      Array.isArray(initialNavigationPath) &&
      initialNavigationPath.length > 0 &&
      autoLoggedRef.current === false
    ) {
      const { moduleId, recordId } = initialNavigationPath[0];
      if (recordId != null) {
        api.post('/api/log_activity', {
          companyId,
          moduleId,
          recordId,
          activityDesc: 'Auto form'
        }).catch(err => console.error('Auto form logging failed:', err));
        // Markeer dat we al gelogd hebben
        autoLoggedRef.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // alleen bij mount
  
  // Module-permissie bepalen
  const modulePerm = userPermission.find(
    p => Number(p.company_portal_module_id) === Number(moduleContent.module_id)
  );
  const hasModulePermission = modulePerm?.permission;


  // 1) Seed viewMode & navigationPath _eenmalig_ uit props als standalone
  const [viewMode, setViewMode] = useState(
    standalone && initialViewMode ? initialViewMode : 'table'
  );
  const [navigationPath, setNavigationPath] = useState(
    standalone && initialNavigationPath
      ? initialNavigationPath
      : moduleContent
      ? [{ moduleId: moduleContent.module_id, recordId: null }]
      : []
  );

  // 2) Bij mount in standalone wéér seeden, maar daarna niet meer
  useEffect(() => {
    if (standalone && initialViewMode && initialNavigationPath) {
      setViewMode(initialViewMode);
      setNavigationPath(initialNavigationPath);
    }
  }, []);  

  // 3) Normale reset wanneer je via menu wisselt (dus wél bij moduleContent changes)
  useEffect(() => {
    if (!standalone && moduleContent) {
      setViewMode('table');
      setNavigationPath([{ moduleId: moduleContent.module_id, recordId: null }]);
    }
  }, [standalone, moduleContent]);

  // 4) Callback om in te zoomen op een record
  const handleOpenForm = ({ recordId, moduleId }) => {
    setNavigationPath(path => [...path, { moduleId, recordId }]);
    setViewMode('form');

    // stuur de logging‐call
    api.post('/api/log_activity', {
      companyId,          // uit de context
      moduleId,           // het geopende module‐ID
      recordId,           // het geopende record‐ID
      activityDesc: `Open form`
    })
    .catch(err => {
      console.error('Activity logging failed:', err);
      // geen user‐feedback nodig, we gaan gewoon door
    });
  };

  // 5) Terug-knop
  const handleBack = () => {
    setNavigationPath(path => {
      if (path.length <= 1) {
        setViewMode('table');
        return path;
      }
      const next = path.slice(0, -1);
      setViewMode(next[next.length - 1].recordId === null ? 'table' : 'form');
      return next;
    });
  };
  
  // Create-knop schakelt naar insert-view
  const handleCreate = () => {
    if (moduleContent.module_insert_form_json_definition) {
      setViewMode('insert');
    } else {
      console.error('Geen insert-form JSON gedefinieerd');
    }
  };

  // Data ophalen in table-view
  useEffect(() => {
    if (!moduleContent || viewMode !== 'table') {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);

    const payload = {
      companyId,
      email: userEmail,
      query: moduleContent.query,
      params:
        moduleContent.params === 'user_email'
          ? [userEmail]
          : []
    };

    (async () => {
      try {
        const { data: rows } = await api.post(
          '/api/iAGateway_get_query',
          payload
        );

        setData(Array.isArray(rows) ? rows : []);
        if (!Array.isArray(rows) || rows.length === 0) {
          throw new Error('No data available');
        }
      } catch (err) {
        if (err.response?.status === 401) {
          await logout();
          navigate(`/login/${companyId}`);
          return;
        }
        console.error('Error fetching module data:', err);
        setError(err.response?.data?.error || err.message);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      } finally {
        setIsLoading(false);
      }
    })();

    // Columns instellen
    if (moduleContent.columns) {
      setColumns(
        moduleContent.columns.sort((a, b) => a.order - b.order)
      );
    }
  }, [
    moduleContent,
    viewMode,
    userEmail,
    companyId,
    logout,
    navigate,
    refreshFlag
  ]);

  // Geen permissie?
  if (!hasModulePermission && !standalone) {
    return <div>No access to module</div>;
  }

  // INSERT-view
  if (viewMode === 'insert') {
    return (
      <InsertForm
        insertJsonDef={moduleContent.module_insert_form_json_definition}
        onSubmit={() => {
          setRefreshFlag(f => !f);
          handleBack();
        }}
        onCancel={handleBack}
      />
    );
  }

  // FORM-view (bestaand record)
  if (viewMode === 'form') {
    // Alleen terug gaan als ofwel dieper in het pad (length>1), of in de normale portal
    const canGoBack = navigationPath.length > 1 || !standalone;
    return (
      <FormPage
        recordId={navigationPath[navigationPath.length - 1].recordId}
        companyPortalModuleId={navigationPath[navigationPath.length - 1].moduleId}
        onClose={handleBack}
        onOpenForm={handleOpenForm}
        showBack={canGoBack}
      />
    );
  }

  // TABLE-view
  return (
    <div>
      <h2 style={{ color: 'gray' }}>{selectedSP_MenuItem}</h2>
      {moduleContent.show_create_button && (
        <button
          className="create-button"
          onClick={handleCreate}
          disabled={!moduleContent.create_record_permission}
        >
          + Create
        </button>
      )}

      <div
        className="module-content"
        style={{
          height: moduleContent.show_create_button
            ? 'calc(80vh - 40px)'
            : '80vh',
          width: '100%'
        }}
      >
        <DataTable_AgGrid
          initialData={data}
          columns={columns}
          isEditable={true}
          config={{
            tablename: moduleContent.tablename,
            primaryKey: moduleContent.primaryKey
          }}
          moduleId={moduleContent.module_id}
          onOpenForm={handleOpenForm}
        />
      </div>

      {isLoading && (
        <div className="loader-wrapper-new">
          <div className="loader-new" />
        </div>
      )}
      {showErrorPopup && <div className="popup">{error}</div>}
      {showPopupMessage && <div className="popup-message">{message}</div>}
    </div>
  );
};


// Styles voor de header-popup overlay en modal
const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle = {
  background: 'white',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.4)',
  width: '400px',
  maxWidth: '80%',
};

export const ManageInvitedSuppliers = () => {
  const [users, setUsers] = useState([]);
  const [modules, setModules] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [headerPopupData, setHeaderPopupData] = useState(null);
  const [error, setError] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [message, setMessage] = useState('');
  const [showPopupMessage, setShowPopupMessage] = useState(false);

  const { companyId, logout, token } = useAuth();

  const parsePermission = raw => {
    try {
      let p = raw;
      if (typeof p === 'string') {
        p = JSON.parse(p);
        if (typeof p === 'string') p = JSON.parse(p);
      }
      if (Array.isArray(p)) return p;
    } catch {}
    return [];
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.post('/api/get_sp_user_permissions', {
          companyId
        });
        if (!data.users) {
          throw new Error('No user permissions returned');
        }
        setUsers(
          data.users.map(u => ({
            ...u,
            json_permission: parsePermission(u.json_permission)
          }))
        );
      } catch (err) {
        // 401 wordt door interceptor al afgehandeld door logout() en redirect
        console.error('Error fetching user permissions:', err);
        setError('Error fetching user permissions');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      }
    })();
  }, [companyId, logout]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.post('/api/get_company_portal_modules', {
          companyId,
          roleId: 6   // 6 = Supplier Portal
        });
        setModules(data.modules || []);
      } catch (err) {
        console.error('Error fetching modules:', err);
        setError('Error fetching modules');
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [companyId, logout]);

  const updateJsonField = async (
    moduleId,
    type,        // 'module' or 'layout'
    layoutIndex, // null for module, or the layout index
    layoutType,  // 'widget' | 'subtable' | 'tabpage‑layout' or null
    headerIndex, // which column/field in that array
    property,    // 'hide' or 'showTotal'
    newValue     // boolean
  ) => {
  
    // build the JSON‑path
    let jsonPath;
    if (type === 'module') {
      jsonPath = `$.columns[${headerIndex}].${property}`;
    } else if (layoutType === 'widget') {
      jsonPath = `$.layout[${layoutIndex}].fields[${headerIndex}].${property}`;
    } else if (layoutType === 'subtable') {
      jsonPath = `$.layout[${layoutIndex}].subtableConfig.columns[${headerIndex}].${property}`;
    } else {
      jsonPath = `$.layout[${layoutIndex}].layoutConfig.column1[${headerIndex}].${property}`;
    }
  
    // pick which JSON‐column to update
    const key = type === 'module'
      ? 'module_json_definition'
      : 'module_form_json_definition';
  
    console.log('Updating JSON path:', jsonPath, '->', newValue, 'key:', key);
  
    try {
      // Axios stuurt via interceptor automatisch de Authorization header mee
      const { data: res } = await api.post('/api/json_path_update_field', {
        module_id:  moduleId,
        company_id: companyId,
        role_id:    '6',  // 6  = Supplier
        key,
        json_path:  jsonPath,
        new_value:  newValue
      })

      console.log('json_path_update_field response:', res)
      if (!res.success) {
        throw new Error(res.error || 'Update failed')
      }

      // — lokaal state updaten met nieuwe JSON-def —
      setModules(prev =>
        prev.map(m => {
          if (m.id !== moduleId) return m
          const def = JSON.parse(m[key])
          if (type === 'module') {
            def.columns[headerIndex][property] = newValue
          } else if (layoutType === 'widget') {
            def.layout[layoutIndex].fields[headerIndex][property] = newValue
          } else if (layoutType === 'subtable') {
            def.layout[layoutIndex].subtableConfig.columns[headerIndex][property] = newValue
          } else {
            def.layout[layoutIndex].layoutConfig.column1[headerIndex][property] = newValue
          }
          return { ...m, [key]: JSON.stringify(def) }
        })
      )

      // — en direct ook de popup-rij bijwerken voor UX —
      setHeaderPopupData(h => ({
        ...h,
        headers: h.headers.map((hdr, idx) =>
          idx === headerIndex ? { ...hdr, [property]: newValue } : hdr
        )
      }))

    } catch (err) {
      console.error('Error updating JSON field:', err)
      setError('Error updating JSON field: ' + (err.message || err))
      setShowErrorPopup(true)
      setTimeout(() => setShowErrorPopup(false), 3000)
    }
  }
  

  const updatePermission = async (
    userEmail,
    permissionKey,
    newValue,
    labelForLayout = ''
  ) => {
    // 1. Update lokaal in de state
    const updatedUsers = users.map(u => {
      if (u.user_email !== userEmail) return u
      const perms = [...u.json_permission]
      const parts = permissionKey.split('_')
      const moduleId = Number(parts[1])

      let modPerm = perms.find(p => p.company_portal_module_id === moduleId)
      if (!modPerm) {
        modPerm = { company_portal_module_id: moduleId, permission: false, layout: [] }
        perms.push(modPerm)
      }

      if (permissionKey.startsWith(`module_${moduleId}_layout_`)) {
        const idx = modPerm.layout.findIndex(l => l && l.label === labelForLayout)
        if (idx >= 0) {
          modPerm.layout[idx].permission = newValue
        } else {
          modPerm.layout.push({ label: labelForLayout, permission: newValue })
        }
      } else {
        modPerm.permission = newValue
      }

      return { ...u, json_permission: perms }
    })
    setUsers(updatedUsers)

    // 2. Vind de geüpdatete user
    const userToUpdate = updatedUsers.find(u => u.user_email === userEmail)
    if (!userToUpdate) return

    // 3. Verstuur de wijziging naar de server via axios-instance
    try {
      const payload = {
        user_email:      userToUpdate.user_email,
        company_id:      companyId,
        json_permission: JSON.stringify(userToUpdate.json_permission)
      }
      const { data } = await api.post('/api/update_sp_user_permission', payload)
      if (!data.success) {
        throw new Error(data.error || 'Update failed')
      }
      console.log(`Permission updated: ${permissionKey}`)
    } catch (err) {
      console.error('Error updating permission:', err)
      setError('Error updating permission: ' + (err.message || err))
      setShowErrorPopup(true)
      setTimeout(() => setShowErrorPopup(false), 3000)
    }
  }

  const renderPopupOverlay = () => {
    if (!headerPopupData) return null;
    const {
      moduleId,
      type,
      layoutIndex,
      layoutType,
      headers,
      headerName
    } = headerPopupData;
  
    // Toon de “Show Totals” kolom alleen voor modules en subtable layouts
    const showTotalsColumn = type === 'module' || layoutType === 'subtable';
  
    return (
      <div className="modal-overlay" onClick={() => setHeaderPopupData(null)}>
        <div className="modal" onClick={e => e.stopPropagation()}>
          <h3>{headerName} – Available fields</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left' }}>Field</th>
                <th style={{ textAlign: 'center' }}>Show</th>
                {showTotalsColumn && (
                  <th style={{ textAlign: 'center' }}>Show Totals</th>
                )}
              </tr>
            </thead>
            <tbody>
              {headers.map((f, i) => (
                <tr key={i}>
                  {/* Field */}
                  <td>{f.headerName}</td>
  
                  {/* Show */}
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      checked={!f.hide}
                      onChange={e => {
                        const nv = !e.target.checked;
                        let jsonPath;
                        if (type === 'module') {
                          jsonPath = `$.columns[${i}].hide`;
                        } else if (layoutType === 'widget' || layoutType === 'tabpage‑layout') {
                          jsonPath = `$.layout[${layoutIndex}].fields[${i}].hide`;
                        } else {
                          // subtable
                          jsonPath = `$.layout[${layoutIndex}].subtableConfig.columns[${i}].hide`;
                        }
                        console.log('Updating JSON path:', jsonPath, '→', nv);
                        updateJsonField(
                          moduleId,
                          type === 'module' ? 'module' : 'layout',
                          type === 'module' ? null : layoutIndex,
                          layoutType,
                          i,
                          'hide',
                          nv
                        );
                      }}
                    />
                  </td>
  
                  {/* Show Totals (alleen bij integer/decimal) */}
                  {showTotalsColumn && (
                    (f.type === 'integer' || f.type === 'decimal') ? (
                      <td style={{ textAlign: 'center' }}>
                        <input
                          type="checkbox"
                          checked={!!f.showTotal}
                          onChange={e => {
                            const nv = e.target.checked;
                            let jsonPath;
                            if (type === 'module') {
                              jsonPath = `$.columns[${i}].showTotal`;
                            } else {
                              // subtable
                              jsonPath = `$.layout[${layoutIndex}].subtableConfig.columns[${i}].showTotal`;
                            }
                            console.log('Updating JSON path:', jsonPath, '→', nv);
                            updateJsonField(
                              moduleId,
                              type === 'module' ? 'module' : 'layout',
                              type === 'module' ? null : layoutIndex,
                              layoutType,
                              i,
                              'showTotal',
                              nv
                            );
                          }}
                        />
                      </td>
                    ) : (
                      // lege cel om de kolomstructuur te bewaren
                      <td />
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => setHeaderPopupData(null)}>Close</button>
        </div>
      </div>
    );
  };  
  
  
  const columns = useMemo(()=>{
    const cols = [{ Header:'Email', accessor:'user_email' }];

    modules.forEach(mod=>{
      cols.push({
        Header:mod.module_description,
        accessor:`module_${mod.id}`,
        Cell:({row})=>{
          const perm = row.original.json_permission
            .find(p=>p.company_portal_module_id===mod.id);
          return (
            <input
              type="checkbox"
              checked={!!perm?.permission}
              onChange={e=>
                updatePermission(
                  row.original.user_email,
                  `module_${mod.id}`,
                  e.target.checked
                )
              }
            />
          );
        },
        headerPopup:()=>{
          const def = JSON.parse(mod.module_json_definition);
          setHeaderPopupData({
            moduleId:mod.id,
            type:'module',
            layoutIndex:null,
            layoutType:null,
            headers:def.columns.map(c=>({
              headerName:c.headerName,
              hide:c.hide,
              showTotal:c.showTotal,
              type: c.type
            })),
            headerName:mod.module_description
          });
        }
      });

      if (mod.module_form_json_definition) {
        const def = JSON.parse(mod.module_form_json_definition);
        def.layout.forEach((item,li)=>{
          if (!item.label) return;
          const lt = item.type; // widget/subtable/tabpage
          const fields = lt==='widget'
            ? item.fields
            : lt==='subtable'
              ? item.subtableConfig.columns
              : item.layoutConfig.column1;
          if (!Array.isArray(fields)) return;

          cols.push({
            Header:item.label,
            accessor:`module_${mod.id}_layout_${item.label}`,
            Cell:({row})=>{
              const perm = row.original.json_permission
                .find(p=>p.company_portal_module_id===mod.id);
              const entry = perm?.layout.find(l=>l&&l.label===item.label);
              return (
                <input
                  type="checkbox"
                  checked={!!entry?.permission}
                  onChange={e=>
                    updatePermission(
                      row.original.user_email,
                      `module_${mod.id}_layout_${item.label}`,
                      e.target.checked,
                      item.label
                    )
                  }
                />
              );
            },
            headerPopup:()=>{
              setHeaderPopupData({
                moduleId:mod.id,
                type:'layout',
                layoutIndex:li,
                layoutType:lt,
                headers:fields.map(f=>({
                  headerName:f.headerName||f.field,
                  hide:f.hide,
                  showTotal:f.showTotal,
                  type: f.type
                })),
                headerName:item.label
              });
            }
          });
        });
      }
    });

    return cols;
  },[modules,users]);

  const rowData = useMemo(()=>{
    return users.map(u=>{
      const base = { user_email:u.user_email, json_permission:u.json_permission };
      modules.forEach(mod=>{
        const perm = u.json_permission.find(p=>p.company_portal_module_id===mod.id);
        base[`module_${mod.id}`] = perm?.permission?'✔':'';
        if (mod.module_form_json_definition && perm) {
          const def = JSON.parse(mod.module_form_json_definition);
          def.layout.forEach(item=>{
            if (!item.label) return;
            const entry = perm.layout.find(l=>l&&l.label===item.label);
            base[`module_${mod.id}_layout_${item.label}`] = entry?.permission?'✔':'';
          });
        }
      });
      return base;
    });
  },[users,modules]);

  if (isLoading) return <div>Loading…</div>;

  return (
    <div style={{height:'78vh'}}>
      <DataTable_ManageInvitations
        data={rowData}
        columns={columns}
        stickyColumns={1}
      />
      {renderPopupOverlay()}
      {showPopupMessage && <div className="popup-message">{message}</div>}
      {showErrorPopup  && <div className="popup">{error}</div>}
    </div>
  );
};


export default memo(SupplierPortal);
